export const API_METHODS = {
	GET: 'get',
	GET_BLOB: 'getBlob',
	POST: 'post',
	PUT: 'put',
	PATCH: 'patch',
	DELETE: 'del',
	POST_BLOB: 'postBlob',
};

// Optional: freeze it so it can't be accidentally modified
Object.freeze(API_METHODS);
